import Base from '../base';
import constructDialog from '../../utils/webcomponents/construct-dialog';

import './portfolio-item-edit-form';

// Button to trigger a dialog
class PortfolioItemAddButton extends Base {
	start() {
		this.on('click');
	}

	onClick() {
		PortfolioItemAddButton.createDialog(this.options);
	}

	static createDialog(portfolioItem) {
		const tagName = 'x-portfolio-item-edit-form';
		const options = { ...portfolioItem, amount: 1 };
		const { isin: title } = options;

		constructDialog({ title }, tagName, { options: JSON.stringify(options) });
	}
}

export default PortfolioItemAddButton;
